;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "UnifiedCheckoutSdk",

  props: {
    jwt: {
      type: String,
      required: true
    },
    clientLibrary: {
      type: String,
      required: true
    },
    clientLibraryIntegrity: {
      type: String,
      required: true
    }
  },

  mounted: function mounted() {
    this.loadCybersourceScript();
  },


  methods: {
    loadCybersourceScript: function loadCybersourceScript() {
      var _this = this;

      if (document.querySelector("script[src=\"" + this.clientLibrary + "\"]")) {
        this.launchCheckout();
        return;
      }

      var script = document.createElement("script");
      script.src = this.clientLibrary;
      script.integrity = this.clientLibraryIntegrity;
      script.crossOrigin = "anonymous";
      script.async = true;

      script.onload = function () {
        _this.launchCheckout();
      };

      document.head.appendChild(script);
    },
    launchCheckout: async function launchCheckout() {
      try {
        var sidebar = false;

        var showArgs = {
          containers: {
            paymentSelection: "#buttonPaymentListContainer",
            paymentScreen: "#embeddedPaymentContainer" }
        };

        var accept = await window.Accept(this.jwt);
        var up = await accept.unifiedPayments(sidebar);

        var transientToken = await up.show(showArgs);

        var completeResponse = await up.complete(transientToken);

        var completeResponsePayload = {
          transientToken: transientToken,
          captureContext: completeResponse
        };
        this.$emit("payment-complete", completeResponsePayload);
      } catch (error) {
        console.error("Unified Checkout error:", error);
        this.$emit("payment-error", error);
      }
    }
  }
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"buttonPaymentListContainer"}}),_vm._v(" "),_c('div',{staticClass:"mt-3",attrs:{"id":"embeddedPaymentContainer"}})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-694592a0", __vue__options__)
  } else {
    hotAPI.reload("data-v-694592a0", __vue__options__)
  }
})()}